module.exports = __webpack_public_path__ + "assets1783936157458/img/duolian-avator.b546edae.svg";